<div class="attachments" *ngIf="showAttachments || (attachments != null && attachments.length > 0)">
	@if (!hideHeadline) {
		<div class="headline">{{ "ATTACHMENTS__HEADLINE" | transloco }}</div>
	}

	@if (v2) {
		<div class="attachments-v2-grid">
			@for (attachment of attachments; track attachment.url) {
				<button
					type="button"
					class="attachments-v2-cell"
					(click)="edit(attachment)"
					[attr.aria-label]="'ATTACHMENTS__OPTIONS_VIEW' | transloco"
				>
					<span
						class="attachments-v2-image"
						[style.background-image]="'url(' + attachment.imageSrc + ')'"
					></span>
				</button>
			}

			@if (!isReadonly) {
				<button
					type="button"
					class="attachments-v2-cell attachments-v2-cell--add"
					(click)="add()"
					[attr.aria-label]="'ATTACHMENTS__ADD' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32" aria-hidden="true">
						add
					</span>
				</button>
			}

			@for (_ of v2Placeholders; track $index) {
				<div class="attachments-v2-cell attachments-v2-cell--placeholder" aria-hidden="true"></div>
			}
		</div>
	} @else {
		<div class="thumbnails">
			<ion-thumbnail *ngFor="let attachment of attachments" (click)="edit(attachment)">
				<img [src]="attachment.imageSrc" alt="image thumbnail" />
			</ion-thumbnail>

			@if (!isReadonly) {
				<ion-thumbnail (click)="add()">
					<ion-icon class="full" name="add-circle-outline"></ion-icon>
				</ion-thumbnail>
			}
		</div>
	}
</div>
